import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_CONFIG_ITEM } from './config-item.gql';
import { GetConfigItem } from './__generated__/GetConfigItem';

const CONFIG_KEY = 'hide-report-attendance';

export function HideReportAttendance() {
  const [queryConfigItem] = useCampfireLazyQuery<GetConfigItem, { key: string }>(GET_CONFIG_ITEM);
  const [enabled, setEnabled] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryConfigItem({ variables: { key: CONFIG_KEY } }).then((response) =>
      setEnabled(
        response.data?.vm.configItem?.configItemValue?.flagValue ?? response.data?.vm.configItem?.defaultValue ?? false
      )
    );
  }, []);

  const saveConfigItem = useCampfireFetch({ defer: true });

  const apiUrl = useApiUrl();
  const onSave = () => {
    saveConfigItem
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: CONFIG_KEY,
          value: !enabled,
        },
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Request failed');
        }
        setEnabled(!enabled);
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      })
      .catch(() => {
        setSnackbar({
          open: true,
          message: 'Unable to update setting',
          variant: 'error',
        });
      });
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(enabled)}
          disabled={saveConfigItem.isLoading}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'hide attendance in reports' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Hide Attendance in Reports
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            {
              'Hide the attendance and time sections when submitting session reports, and hide times when viewing reports. Applies to all roles.'
            }
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
